import { Layout, DescriptionList, InlineGroup } from '@vwfs-bronson/bronson-react';
import { ModalOfferDetailsAdditionalProducts } from './ModalOfferDetailsAdditionalProducts';
import { financialFormat } from '../../../../helpers/financialFormat';
import { formatWithThousandsSeparator } from '../../../../helpers/formatWithThousandsSeparator';
import { getGrantType } from '../../../../helpers/getGrantType';
import { getComisionAperturaLiteral } from '../../../../helpers/getComisionAperturaLiteral';
import { ProductTypeEnum } from '../../../../types/enums';
import { useLocationVehicle } from '../../../../hooks/useLocationVehicle';

export const FinanceInfo = ({ offer }) => {
  const locationVehicle = useLocationVehicle();

  if (!offer) return null;

  const { TablaCuotas } = offer.MonthlyFeePerYear ?? {};
  const thereIsBonus = offer.ImporteBonificacion !== '0';
  const bonusAmount = locationVehicle.IsCanarias ? offer.ImportePVP : offer.ImporteInicialFinanciado;
  return (
    <Layout className="row u-mb">
      <Layout.Item default="1/1">
        <InlineGroup className="u-mb">
          <DescriptionList grid>
            <DescriptionList.Group termText="Campaña">
              <b>{offer.Campain?.Value}</b>
            </DescriptionList.Group>
          </DescriptionList>
          <DescriptionList grid>
            <DescriptionList.Group termText="Aplazamiento">
              <b>{offer.Months} Meses</b>
            </DescriptionList.Group>
          </DescriptionList>
          {offer.Km !== '' && (
            <DescriptionList grid>
              <DescriptionList.Group termText="Kilometraje Anual">
                <b>{formatWithThousandsSeparator(offer.Km, '.')} km</b>
              </DescriptionList.Group>
            </DescriptionList>
          )}
          <DescriptionList grid>
            <DescriptionList.Group termText="Entrada">
              <b>{parseInt(offer.InitAmount) > 0 ? financialFormat(offer.InitAmount) + ' €' : 'No'}</b>
            </DescriptionList.Group>
          </DescriptionList>
          <DescriptionList grid>
            <DescriptionList.Group termText="TIN">
              <b>{financialFormat(offer.PorcentajeTIN)} %</b>
            </DescriptionList.Group>
          </DescriptionList>
          <DescriptionList grid>
            <DescriptionList.Group termText="TAE">
              <b>{financialFormat(offer.PorcentajeTAE)} %</b>
            </DescriptionList.Group>
          </DescriptionList>
          <DescriptionList grid>
            <DescriptionList.Group termText={getComisionAperturaLiteral()}>
              <b>{financialFormat(offer.ComisionApertura)} €</b>
            </DescriptionList.Group>
          </DescriptionList>
          <DescriptionList grid>
            <DescriptionList.Group termText="Importe del crédito">
              <b>{financialFormat(offer.ImporteTotalFinanciado)} €</b>
            </DescriptionList.Group>
          </DescriptionList>
          {thereIsBonus && (
            <>
              <DescriptionList grid>
                <DescriptionList.Group termText="Importe bonificación VWFS">
                  <b>{financialFormat(offer.ImporteBonificacion)} €</b>
                </DescriptionList.Group>
              </DescriptionList>
              <DescriptionList grid>
                <DescriptionList.Group termText="Importe después de bonificación">
                  <b>{financialFormat(bonusAmount)} €</b>
                </DescriptionList.Group>
              </DescriptionList>
            </>
          )}
        </InlineGroup>
        <br />
        <ModalOfferDetailsAdditionalProducts offer={offer}></ModalOfferDetailsAdditionalProducts>
        <br />
        <InlineGroup>
          {offer.Product.Key === 'AF' ? (
            <Layout>
              <Layout.Item>
                {TablaCuotas.map((quote, index) => (
                  <div key={index}>
                    {`${quote.NumCuotas} cuotas mensuales de `}
                    <b>{quote.ImpNominal} €</b>
                  </div>
                ))}
              </Layout.Item>
            </Layout>
          ) : (
            <DescriptionList grid>
              <DescriptionList.Group termText="Cuota mensual">
                <b>{financialFormat(offer.FeeAmount)} €</b>
              </DescriptionList.Group>
            </DescriptionList>
          )}
          {offer.Product.Key === ProductTypeEnum.AUTOCREDIT && (
            <DescriptionList grid>
              <DescriptionList.Group termText="Valor Mínimo Garantizado">
                <b>{financialFormat(offer.ImportePrecioEstimadoVenta)} €</b>
              </DescriptionList.Group>
            </DescriptionList>
          )}
          {offer.Product.Key === 'AF' && (
            <DescriptionList grid>
              <DescriptionList.Group termText="Periodo Mínimo de Permanencia">
                <b>{offer.MonthlyFeePerYear.PeriodoMinimoPermanencia} meses</b>
              </DescriptionList.Group>
            </DescriptionList>
          )}
          {offer.IndicadorPlan !== '' && (
            <>
              <DescriptionList grid>
                <DescriptionList.Group termText="Subvención">
                  <b>{getGrantType(offer.IndicadorPlan)}</b>
                </DescriptionList.Group>
              </DescriptionList>
              <DescriptionList grid>
                <DescriptionList.Group termText="Importe subvención">
                  <b>{financialFormat(offer.ImporteSubvencion)} €</b>
                </DescriptionList.Group>
              </DescriptionList>
            </>
          )}
        </InlineGroup>
      </Layout.Item>
    </Layout>
  );
};
